import { Portal } from '@ark-ui/react';
import type { FC } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import { Color } from '~/utils/styles/enums';
import appIcon from '@app/_assets/app_icon_pc.png';
import { Actionsheet } from '@app/_components/actionsheet';
import { Button } from '@app/_components/button';
import { VStack, Image, Paragraph, Center } from '@styled-system/jsx';

type VisibilityConfig = Partial<{
  disableAppInstall: boolean;
  disableLogin: boolean;
}>;

interface Props {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  visibilityConfig?: VisibilityConfig;
  onOpenAppClick?: () => void;
  onClickLogin?: () => void;
  isOpen: boolean;
  close: () => void;
}

export const AppInstallOrLoginActionsheet: FC<Props> = ({
  title,
  description,
  visibilityConfig,
  onOpenAppClick,
  onClickLogin,
  isOpen,
  close,
}) => {
  return (
    <>
      <Portal>
        <Actionsheet open={isOpen} onClose={close}>
          <VStack position="relative" zIndex="share_popover" gap="12px">
            <Center
              position="absolute"
              top="-36px"
              padding="8px"
              bg="white"
              borderRadius="20px"
            >
              <Image
                src={appIcon}
                alt="アプリで開く"
                width="56px"
                height="56px"
              />
            </Center>
            <Center
              position="absolute"
              top="0"
              right="0"
              cursor="pointer"
              p="4"
              onClick={close}
            >
              <RiCloseFill size="24px" color={Color.ACCENT_700} />
            </Center>
            <VStack
              minH="150px"
              bg="white"
              minW="100%"
              borderTopLeftRadius="8px"
              borderTopRightRadius="8px"
              justifyContent="center"
              alignItems="center"
              textAlign="center"
              padding="24px 24px 16px 24px"
            >
              <Paragraph fontSize="size_18" fontWeight="700" marginTop="16px">
                {title || (
                  <>
                    アプリならすべて機能を
                    <br />
                    お楽しみいただけます
                  </>
                )}
              </Paragraph>
              <Paragraph fontSize="size_14" color="accent.700" marginTop="8px">
                {description ||
                  '800万ある作品の中からあなたにぴったりの物語を探そう'}
              </Paragraph>
              <VStack w="100%" gap="2">
                {visibilityConfig?.disableAppInstall !== true && (
                  <Button onClick={onOpenAppClick} h="50px" marginTop="24px">
                    テラーノベルで開く
                  </Button>
                )}
                {visibilityConfig?.disableLogin !== true && (
                  <Button type="link" h="50px" onClick={onClickLogin}>
                    ログイン
                  </Button>
                )}
              </VStack>
            </VStack>
          </VStack>
        </Actionsheet>
      </Portal>
    </>
  );
};
